

export class Global {

    static SIZE_GET_ALL = 999999999;
    static PREFIX_RECORD = 'finexus';

    static MAESTRO = 'maestro';
    static TRANSACCION = 'transaccion';

    static ASIENTO = 'asiento';
    static RENDICION_CAJA = 'rendicion_caja';
    static RENDICION = 'rendicion';

    public static ORIGEN_TRANSACCIONES = [
        { valor: 'asiento', nombre: 'Asiento' },
        { valor: 'rendicion_caja', nombre: 'Rendición de Caja' },
        { valor: 'rendicion', nombre: 'Rendición' },
    ]

}
